export enum Status {
    SUCCESS = 'success',
    FAIL = 'fail',
    ERROR = 'error',
}

export const ACCESS_TOKEN = 'accessToken';

export enum SubscriptionPlans {
    Free = 'free',
    Premium = 'premium',
}

export enum MediaTypes {
    Video = 'video',
    Audio = 'audio',
}

export enum Persona {
    Trader = 'trader',
    Salesperson = 'salesperson',
    Engineer = 'engineer',
    Other = 'other',
}

export const DAILY_AFFIRMATION_CONTENT_TITLE = 'Daily Affirmation';

export enum CourseTrackType {
    Trader = 'trader',
    General = 'general',
}

export enum CourseLevel {
    Beginner = 'beginner',
    Intermediate = 'intermediate',
    Advanced = 'advanced',
}

export enum ScheduleTargetType {
    Content = 'content',
    Course = 'course',
}

export enum ScheduleCadence {
    Daily = 'daily',
}

export enum ScheduleQueueItemStatus {
    Queued = 'queued',
    Published = 'published',
    Skipped = 'skipped',
    Failed = 'failed',
}
